// extracted by mini-css-extract-plugin
export default {"kcbCarrier":"kcbCarrier_kcbCarrier__rnkWV"};